import React from 'react';
import {
  Breadcrumb, Form, Input, Button,
} from 'antd';
import { useTranslation } from 'react-i18next';
import { SaveOutlined } from '@ant-design/icons';

import withAuth from '@common/hocs/withAuth';
import MainLayout from '@common/layouts/MainLayout';

import useProfile from './useProfile';
import styles from './Profile.module.less';

function Profile() {

  const { t } = useTranslation();
  const {
    onFinishFailed, onFinish,
    formOnValuesChange,
    dataForm,
    cancelCreateEditUser,
  } = useProfile();

  return (
    <MainLayout applyWidthLimit>
      <div className={styles.wrapper}>
        <Breadcrumb className={styles.date_wrapper}>
          <Breadcrumb.Item className={styles.breadcrumb}>
            {t('views.users.breadcrumb.me')}
          </Breadcrumb.Item>

        </Breadcrumb>
        <Form
          name="CreateUser"
          labelCol={{ span: 10 }}
          wrapperCol={{ span: 22 }}
          layout="vertical"
          className={styles.totalForm}
          initialValues={{
            ...dataForm, remenber: true,
          }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          onValuesChange={formOnValuesChange}
          autoComplete="off"
        >
          <div className={styles.containerForm}>
            <div className={styles.column}>

              <Form.Item
                className={styles.label}
                label={t('forms.users.labels.email')}
                name="email"
                rules={[
                  { required: true, message: t('forms.users.rules.email') },
                  { type: 'email', message: t('forms.users.rules.type_email') },
                ]}
              >
                <Input className={styles.input} placeholder={t('forms.users.placeholders.email')} />
              </Form.Item>

              <Form.Item
                className={styles.label}
                label={t('forms.users.labels.phone')}
                name="phone"
                rules={[
                  { required: true, message: t('forms.users.rules.phone') },
                ]}
              >
                <Input type="number" className={styles.input} placeholder={t('forms.users.placeholders.phone')} />
              </Form.Item>

            </div>
            <div className={styles.column}>

              <Form.Item
                className={styles.label}
                label={t('forms.users.labels.name')}
                name="first_name"
                rules={[
                  { required: true, message: t('forms.users.rules.name') },
                ]}
              >
                <Input className={styles.input} placeholder={t('forms.users.placeholders.name')} />
              </Form.Item>

              <Form.Item
                className={styles.label}
                label={t('forms.users.labels.last_name')}
                name="last_name"
                rules={[
                  { required: true, message: t('forms.users.rules.last_name') },
                ]}
              >
                <Input className={styles.input} placeholder={t('forms.users.placeholders.last_name')} />
              </Form.Item>

            </div>
          </div>
          <Form.Item wrapperCol={{ offset: 0 }} className={styles.containerBtn}>
            <div>
              {/* {(!idToEdit)
                ? (
                  <>
                    <Switch size="default" defaultChecked={isAdmin} onChange={setIsAdmin}
                    checkedChildren="1" unCheckedChildren="0" />
              &nbsp;
                    {t('forms.users.labels.is_admin')}
                  </>
                ) : null} */}
            </div>
            <div>
              <Button className={styles.btnCancel} onClick={cancelCreateEditUser}>
                {t('forms.users.buttons.cancel')}
              </Button>
              <Button className={styles.btn} type="primary" htmlType="submit" icon={<SaveOutlined />}>
                {/* {(!idToEdit) ? t('forms.users.buttons.create') : } */}
                {t('forms.users.buttons.update')}
              </Button>
            </div>
          </Form.Item>
        </Form>
      </div>
    </MainLayout>
  );

}

export default withAuth(Profile);
